export function validateImageSize(file) {
  const MAX_SIZE_BYTES = 20 * 1024 * 1024

  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      if (img.width >= 250 && img.height >= 250 && file.size <= MAX_SIZE_BYTES) {
        resolve()
      } else {
        reject(new Error('error'))
      }
    }
    img.onerror = () => {
      reject(new Error('error'))
    }
    img.src = URL.createObjectURL(file)
  })
}
